import Vue from "vue";
import { getUITranslation } from "../utils/get_ui_translation";
import * as Popup from "../framework/components/popup";
import * as API from "../framework/api.js";

document.addEventListener("DOMContentLoaded", function () {
  if ($(".price-form").length > 0) {
    $(".price-form").each(function () {
      let initialEditPrice = $(this).data("edit-costs");
      let costs = $(this).data("costs");
      // The commercial discount of the customer whose price is edited, if any: the totals are scaled by it
      const discount = $(this).data("discount") || null;

      costs = _.map(costs, function (cost) {
        cost.cost_mode = cost.cost_mode || "per_customer";
        return cost;
      });

      const initialShowCustomerTypesCosts = costs.some(
        (cost) =>
          cost.cost !== cost.cost_individual || cost.cost !== cost.cost_independant || cost.cost_individual !== cost.cost_independant
      );

      const initialShowMonthly = costs.some((cost) => cost.monthly);

      const empty_costs = [
        {
          description: getUITranslation("Formation"),
          cost: 0,
          cost_individual: 0,
          cost_independant: 0,
          monthly: false,
          type: "training",
          cost_mode: "per_customer",
          vat: null,
        },
      ];
      let viewmodel = new Vue({
        el: this,
        data: {
          editPrice: initialEditPrice,
          costs: costs.length > 0 ? costs : empty_costs,
          discount: discount,

          // Summary without VAT
          price: 0,
          price_individual: 0,
          price_independant: 0,

          // Summary with VAT
          price_with_vat: 0,
          price_individual_with_vat: 0,
          price_independant_with_vat: 0,

          // Summary with VAT before the commercial discount, shown struck out next to the final total
          price_with_vat_undiscounted: 0,
          price_individual_with_vat_undiscounted: 0,
          price_independant_with_vat_undiscounted: 0,

          hasError: false,
          showCustomerTypesCosts: initialShowCustomerTypesCosts,
          initialShowCustomerTypesCosts: initialShowCustomerTypesCosts,
          showMonthly: initialShowMonthly,
        },
        methods: {
          toggleEditPrice: onToggleEditPrice,
          addCost: onAddCost,
          costChanged: onCostChanged,
          removeCost: onRemoveCost,
          descriptionChanged: checkDescriptions,
          updateTotals: updateTotals,
          onShowCustomerTypesCostsChange,
          toggleShowMonthly,
          isTraineeCostType,
        },
        computed: {
          costsJson: function () {
            return JSON.stringify(this.costs);
          },
        },
        created: function () {
          this.debouncedUpdateTotals = _.debounce(this.updateTotals, 500);
        },
      });

      // On pages with a lot of forms (e.g., price page with lots of modules), we have N instances of this viewmodel.
      // But all of the forms are actually hidden and the viewmodels are there just to handle the shown state of the form, then the full form.
      // We don't need to compute these until the form is actually shown.
      //
      // Since the shownness of the form varies from page to page (accordion, popup), an observer is a good solution.
      let hasIntersectedOnce = false;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasIntersectedOnce) {
            hasIntersectedOnce = true;
            viewmodel.costChanged("company");
            viewmodel.descriptionChanged();
          }
        });
      });

      observer.observe(viewmodel.$el.querySelector(".js-price-form-observer"));

      const accordion = viewmodel.$el.querySelector(".accordion__item");
      if (accordion) {
        accordion.addEventListener("toggle", () => {
          if (!accordion.open && !initialEditPrice) {
            // On accordion close, cancel the edit mode
            viewmodel.editPrice = false;
          }
        });
      }
    });
  }
});

function updateTotals() {
  if (costsAreUndefined(this.costs)) return;

  API.fetchJSON(p`/ajax/costs/compute`, {
    method: "POST",
    body: JSON.stringify({
      costs: this.costs,
      duration_in_days: 1,
      duration_in_hours: 1,
      duration_in_ue: 1,
      discount: this.discount,
    }),
  }).then((data) => {
    this.price = Number(data.company.toFixed(2));
    this.price_individual = Number(data.individual.toFixed(2));
    this.price_independant = Number(data.independant.toFixed(2));
    this.price_with_vat = Number(data.company_with_vat.toFixed(2));
    this.price_individual_with_vat = Number(data.individual_with_vat.toFixed(2));
    this.price_independant_with_vat = Number(data.independant_with_vat.toFixed(2));

    if (data.undiscounted) {
      this.price_with_vat_undiscounted = Number(data.undiscounted.company_with_vat.toFixed(2));
      this.price_individual_with_vat_undiscounted = Number(data.undiscounted.individual_with_vat.toFixed(2));
      this.price_independant_with_vat_undiscounted = Number(data.undiscounted.independant_with_vat.toFixed(2));
    }
  });
}

function onCostChanged(type) {
  let newCosts = [];

  for (let cost of this.costs) {
    let val = cost.cost;
    let write_everywhere = type == "company" && this.showCustomerTypesCosts == false;

    if (!_.isNaN(val) && write_everywhere) {
      cost.cost_independant = val;
      cost.cost_individual = val;
    }

    newCosts.push(cost);
  }

  this.costs = newCosts;
  this.debouncedUpdateTotals();
}

function onAddCost() {
  if (this.costs.length == 1) {
    this.costs.push({
      description: getUITranslation("Frais pédagogiques"),
      cost: 0,
      cost_individual: 0,
      cost_independant: 0,
      monthly: false,
      type: "training",
      cost_mode: "per_customer",
      vat: null,
    });
  } else {
    this.costs.push({
      description: "",
      cost: 0,
      cost_individual: 0,
      cost_independant: 0,
      monthly: false,
      type: "training",
      cost_mode: "per_customer",
      vat: null,
    });
    this.hasError = true;
  }
}

function onRemoveCost(cost) {
  this.costs = _.without(this.costs, cost);
  onCostChanged.apply(this, ["company"]);
  checkDescriptions.apply(this);
}

function onToggleEditPrice(e) {
  e.preventDefault();
  e.stopPropagation();
  this.editPrice = !this.editPrice;

  // Open accordion if closed
  if (this.editPrice) {
    const accordion = this.$el.querySelector(".accordion__item");
    if (accordion) {
      accordion.open = true;
    }
  }
}

function checkDescriptions() {
  for (let cost of this.costs) {
    if (cost.description == null || cost.description.length == 0) {
      this.hasError = true;
      return;
    }
  }
  this.hasError = false;
}

function costsAreUndefined(costs) {
  return _.some(costs, function (cost) {
    return cost.cost === "" || cost.cost_individual === "" || cost.cost_independant === "";
  });
}

async function onShowCustomerTypesCostsChange(e) {
  // Was checked, new value is false
  if (!this.showCustomerTypesCosts) {
    // Temporarily set back to true to avoid blinking, and show the original
    // state when the user cancels
    e.target.checked = true;
    this.showCustomerTypesCosts = true;

    if (!(await Popup.confirm("#hide-customer-types-costs-confirm"))) {
      return;
    }

    this.costs = this.costs.map((cost) => {
      cost.cost_independant = cost.cost;
      cost.cost_individual = cost.cost;
      return cost;
    });
    this.showCustomerTypesCosts = false;
  }
}

function toggleShowMonthly() {
  this.showMonthly = !this.showMonthly;
}

function isTraineeCostType(cost) {
  return !cost.cost_mode.includes("customer");
}
